import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("cc_pssm_api");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  return config;
}, function (error) {
  console.log('AN ERROR REQUEST', error)
});

const currentAnnee = localStorage.getItem("currentAnnee")
  ? JSON.parse(localStorage.getItem("currentAnnee"))
  : null;

export const listeDesPresenceCatechumenePaginee = async (page = 1, size = 10, date = "", dateFin = "", classe = "") => {  
  return await axios.get(
    BASE_URL(`presence-catechumene/query?page=${page}&size=${size}&date=${date}&fin=${dateFin}&classe=${classe}&anneeScolaire=${currentAnnee._id}`),
    {}
  );
};

export const ajouterUnePresenceCatechumene = async (values) => {
  return await axios.post(
    BASE_URL(`presence-catechumene`),
    values
  );
};

export const modifierUnePresenceCatechumene = async (values, presenceId) => {
  return await axios.put(
    BASE_URL(`presence-catechumene/${presenceId}`),
    values
  );
};

export const supprimerUnePresenceCatechumene = async (presenceId) => {
  return await axios.delete(
    BASE_URL(`presence-catechumene/${presenceId}/remove`),
    {}
  );
};

export const supprimerPresenceCatechumeneDeLaClasse = async (presenceId) => {
  return await axios.delete(
    BASE_URL(`presence-catechumene/${presenceId}/delete-classe`),
    {}
  );
};
